import { SelectOptionType } from 'types/selectOptions';

export const getCountryCodes = (countryCode: string): string => {
    return countryCode === 'cs' ? 'cz' : countryCode;
};

export const getCountryOptionWithFallbackByCountryName = (
    countryName: string,
    countries: SelectOptionType[],
): SelectOptionType => {
    if (countries.length === 0) {
        return {
            label: '',
            value: '',
        };
    }

    return countries.find(({ label }) => label === countryName) ?? countries[0];
};
